<span class="brandlogo" role="img" [attr.aria-label]="appName"></span>
<span class="appName">{{ appName }}</span>
